import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import UserStore from "../../stores/UserStore";
import Google from "../../icons/Google";
import Styles from "../SignupOptions/styles.module.css";
import { hRatio, triggerEvent } from "../../constants/utils";
import { hover } from "framer-motion";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { set } from "mobx";

export default function ICSignup() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("")

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleEmailChange = (event) => {
    setFormData((prev) => ({ ...prev, email: event.target.value }));
    UserStore.setFields("email", event.target.value);
  };

  const handlePasswordChange = (event) => {
    setFormData((prev) => ({ ...prev, password: event.target.value }));
    UserStore.setFields("password", event.target.value);
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Enter a valid email";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password should be at least 6 characters long";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("")
    if (validate()) {
      //all fields are filled properly
      // console.log("Form submitted:", formData);
      try{
        const result = await UserStore.createUserAccountArgs(formData.email, formData.password);
        if(result && result.success){
          navigate("/interactive/login");
        }
        else{
          setApiError("Account creation failed, please try again")
        }
      }
      catch(err){
        setApiError("Account creation failed, please try again")
      }
    }
  };

  const SignupOptionBtn = ({ text, icon, onClick, style }) => {
    const [isPressed, setIsPressed] = useState(false);
    

    return (
      <div className={Styles.SignupOptionBtnContainer} style={style}>
        <div
          className={Styles.SignupOptionBtn}
          style={{ opacity: isPressed ? 0.5 : 1 }}
          onClick={onClick}
          onMouseDown={() => setIsPressed(true)}
          onMouseUp={() => setIsPressed(false)}
        >
          <div className={Styles.SignupBtnIcon}>{icon}</div>
          <p className={Styles.SignupBtnTxt}>{text}</p>
        </div>
      </div>
    );
  };

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(true);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBD446] px-4">
      <div className="max-w-md w-full bg-[#FFECAE] p-8 rounded-2xl shadow-md">
        {/* logo */}
        <div className="mb-6">
          <img
            src={require("../../assets/new_onboarding/Evolve_dark.webp")}
            alt=""
            className="mx-auto h-8 object-contain"
          />
        </div>

        {/* Signup form */}
        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* email */}
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-left text-sm font-medium text-gray-700"
            >
              Email*
            </label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleEmailChange}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="you@example.com"
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email}</p>
            )}
          </div>

          {/* password */}
          <div>
            <label
              htmlFor="password"
              className="block text-left text-sm font-medium text-gray-600"
            >
              Password*
            </label>
            <div className="relative">
              <input
                type={!showPassword ? "text" : "password"} // 👈 toggle type
                id="password"
                value={formData.password}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10" // 👈 add right padding
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                onClick={() => setShowPassword((prev) => !prev)} // 👈 toggle state
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* submit */}
          <div>
            <button
              type="submit"
              className="w-full bg-blue-900 text-white py-2 rounded-xl"
            >
              Sign up
            </button>
          </div>
          {apiError.length>0 ? <p className="text-red-600">Something went wrong please try again</p> : ""}
        </form>
      </div>
    </div>
  );
}
